/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/DailyChallengeCalendar',['pixi', 'absolute', 'absolute/stringmanager', 'absolute/screenmetrics', 'absolute/coords', 'MenuUI/Label',
	'Solitaire/MvvmStructure/Service/SolitaireDailyChallengeService', 'lodash', 'absolute/platform',
	'MenuUI/ControlFocusManager', 'Managers/ScaleManager'],
	function (PIXI, Absolute, _s, ScreenMetrics, Coords, Label, SolitaireDailyChallengeService, _, Platform, ControlFocusManager, ScaleManager) {
		"use strict";

		var DCDateTile = function (day, date, completed, onSelected, selected) {
			this.initDCDateTile(day, date, completed, onSelected, selected);
		};

		DCDateTile.font = {
			size: 30
		}

		DCDateTile.size = {
			width: 218,
			height: 76
		};

		DCDateTile.bgColors = {
			notavailable: 0x0e3a6d,
			notstarted: 0xff4a04,
			started: 0x0380fc,
			completed: 0x1bc400,
			futuredate: 0x0e4485
		};


		DCDateTile.constructor = DCDateTile;
		DCDateTile.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		DCDateTile.prototype.initDCDateTile = function (day, date, completed, onSelected) {

			PIXI.DisplayObjectContainer.call(this);

			this.date = date;
			this.completed = completed;
			this.onSelected = onSelected;
			this.available = false;


			this.onShow();

			if (this.date) {

				this.dayStyle = {
					font: (DCDateTile.font.size) + 'px Arial',
					fill: '#ffffff',
					fontFamily: 'segoe',
					tint: 0xffffff,
					align: 'left'
				};

				this.completedStyle = {
					font: (DCDateTile.font.size) / 1.25 + 'px Arial',
					fill: '#ffffff',
					fontFamily: 'segoe',
					tint: 0xffffff,
					align: 'right'
				};

				if (!(this.date < new Date())) {
					this.dayStyle.fill = '#0f3a6d';
					this.completedStyle.fill = '#113766';
				} else {
					this.available = true;
				}

				if (day > 0) {
					var dayLabel = new PIXI.Text(day.toString(), this.dayStyle);
					dayLabel.position.set(
						Absolute.Coords.x(8),
						Absolute.Coords.y(3)
					);
					dayLabel.anchor.set(0, 0);
					this.addChild(dayLabel);
				}

				this.completedLabel = new PIXI.Text(this.completed.toString() + "/5", this.completedStyle);
				this.completedLabel.position.set(
					this.width - 8,
					this.height
				);
				this.completedLabel.anchor.set(1, 1);

				this.completedLabel.visible = this.date < new Date();
				this.addChild(this.completedLabel);

				this.ribbon = PIXI.Sprite.fromFrame('dailychallenge/challenge-perfect-complete.png');
				this.ribbon.visible = false;

				this.ribbon.x = this.width - this.completedLabel.width - Coords.x(2);
				this.ribbon.y = this.height - this.completedLabel.height - Coords.y(11);

				this.addChild(this.ribbon);

			}

			this.focusIndicator = new PIXI.Graphics();
			this.focusIndicator.lineStyle(2.5, 0xFFFFFF);
			this.focusIndicator.drawRect(0, 0, this.width, this.height);

		};

		DCDateTile.prototype.onClick = function (available, evt) {
			if (typeof this.onSelected === 'function') {
				this.onSelected(this.date, available, evt.target);
			}
			this.selected = available;
			if (!available) {
				Absolute.AudioManager.playSound('button');
				this.onHide();
			}
			this.onShow();
		};

		DCDateTile.prototype.buildBackground = function () {
			var bgColor = DCDateTile.bgColors.notavailable;

			if (this.date) {
				if (this.completed > 0) {
					if (this.completed === 5) {
						bgColor = DCDateTile.bgColors.completed;
					} else {
						bgColor = DCDateTile.bgColors.started;
					}
				} else {
					if (this.date < new Date()) {
						bgColor = DCDateTile.bgColors.notstarted;
					} else {
						bgColor = DCDateTile.bgColors.futuredate;
					}
				}
			}


			var bg = new PIXI.Graphics(),
				bgContainer = new PIXI.DisplayObjectContainer();

			bg.beginFill(bgColor);
			bg.drawRect(0, 0, Coords.x(DCDateTile.size.width), Coords.y(DCDateTile.size.height));
			bg.endFill();
			bgContainer.addChild(bg);

			this.addChildAt(bgContainer, 0);

			return bgContainer;
		};

		DCDateTile.prototype.selectTile = function () {
			this.selectedOverlay = new PIXI.Graphics();
			this.selectedOverlay.beginFill(0xffffff, 0.3);
			this.selectedOverlay.lineStyle(Coords.x(2.5), 0xffffff, 1);
			var width = Absolute.Coords.x(DCDateTile.size.width),
				height = Absolute.Coords.y(DCDateTile.size.height);
			this.selectedOverlay.drawRect(0, 0, width, height);
			this.selectedOverlay.endFill();
			this.addChild(this.selectedOverlay);
		};

		Object.defineProperty(DCDateTile.prototype, "selected", {
			get: function () {
				return this._selected;
			},
			set: function (value) {
				this._selected = value;
				value ? this.selectTile() : this.removeChild(this.selectedOverlay);
				this.addHoverGraphic();
			}
		});

		DCDateTile.prototype.onHide = function () {
			this.interactive = false;
			this.buttonMode = false;
		};

		DCDateTile.prototype.onShow = function (completeCount) {

			if (_.isNumber(completeCount)) {
				this.completed = completeCount;
			}

			if (this.currentBackground) {
				this.removeChild(this.currentBackground);
			}

			this.currentBackground = this.buildBackground();

			if (completeCount) {
				this.completedLabel.setText(completeCount.toString() + '/5');
			}

			if (_.isNumber(completeCount) && this.date) {
				this.hitArea = new PIXI.Rectangle(0, 0, this.width, this.height);
				this.mouseup = this.touchend = this.onClick.bind(this, this.date < new Date());
				this.interactive = true;
				this.buttonMode = true;
			} else {
				this.mouseup = this.touchstart = function () {
				};
				this.interactive = false;
				this.buttonMode = false;
			}

			if (!Platform.supportsTouch() && this.date && this.date <= Date.now() && !this.hoverGraphic) {
				this.addHoverGraphic();
				this.mouseover = function (evt) {
					// bugfix: Bug 193128:[Solitaire][M4][Daily Challenge] The 'Menu' and 'Back' button become highlighted when hovering over challenges or dates.
					setTimeout(function () {
						this.addChild(this.hoverGraphic);
					}.bind(this), 0);
				};
				this.mouseout = function (evt) {
					this.removeChild(this.hoverGraphic);
				};
			}

			if (_.isNumber(completeCount) && completeCount > 0) {
				if (completeCount === 5) {
					this.ribbon.visible = true;
					this.completedLabel.visible = false;
				}
			}
		};

		DCDateTile.prototype.addHoverGraphic = function () {
			if (this.hoverGraphic) this.removeChild(this.hoverGraphic);
			this.hoverGraphic = new PIXI.Graphics();
			this.hoverGraphic.beginFill(0xffffff, 0);
			this.hoverGraphic.lineStyle(this._selected ? Coords.x(3.5) : Coords.x(2.5), 0xffffff, 1);
			this.hoverGraphic.drawRect(0, 0, Absolute.Coords.x(DCDateTile.size.width), Absolute.Coords.y(DCDateTile.size.height));
			this.hoverGraphic.endFill();
		};


		DCDateTile.prototype.handleActivate = function () {
			if (this.available) {
				Absolute.AudioManager.playSound('button');
				this.onClick(this.date < new Date(), { target: this });
			}
		};

		DCDateTile.prototype._focusChanged = function () {
			if (this._hasFocus) {
				this.addChild(this.focusIndicator);
			} else {
				if (this.children.indexOf(this.focusIndicator) !== -1) {
					this.removeChild(this.focusIndicator);
				}
			}
		};

		Object.defineProperty(DCDateTile.prototype, "focus", {
			get: function () {
				return this._hasFocus;
			},
			set: function (value) {
				this._hasFocus = value;
				this._focusChanged();
				return value;
			}
		});


		var DailyChallengeCalendar = function (dailyChallengeMenu) {
			this.initDailyChallengeCalendar(dailyChallengeMenu)
		};

		DailyChallengeCalendar.constructor = DailyChallengeCalendar;
		DailyChallengeCalendar.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		DailyChallengeCalendar.prototype.initDailyChallengeCalendar = function (dailyChallengeMenu) {
			PIXI.DisplayObjectContainer.call(this);

			this.dailyChallengeMenu = dailyChallengeMenu;

			this.startingHeight = this.dailyChallengeMenu.config.challengesMenuTabHeight - 80; // Somewhere 80ish is hardcoded top pad the calendar, I cant find it so I'm using this to remove that padding.
			this.calendarMenuHeight = this.dailyChallengeMenu.config.calendarMenuHeight - this.dailyChallengeMenu.config.menusShadowSize;
			this.calendarScaleAdjustment = this.dailyChallengeMenu.config.calendarMenuHeight / (580);
			this.calendarPadding = 20;
			this.calendarMenuTilePadding = 10;
			this.calendarMenuDayOfWeekFontSize = 25*this.calendarScaleAdjustment;
			this.calendarMenuTileHeight = (this.calendarMenuHeight -
				2 * this.calendarPadding -
				this.calendarMenuDayOfWeekFontSize ) / 6 -
				this.calendarMenuTilePadding;

			DCDateTile.size.height = this.calendarMenuTileHeight;
			DCDateTile.font.size = 30 * this.calendarScaleAdjustment;

			this.colSpace = Coords.x(this.calendarMenuTilePadding);
			this.rowSpace = Coords.y(this.calendarMenuTilePadding);

			this.buildColumnHeadings();
			this.buildCalendarGrid();

			this.hitArea = new PIXI.Rectangle(0, 0, this.width, this.height);
			this.interactive = true;
			this.buttonMode = false;

			this.initInfoBox();

			this.mouseup = this.touchstart = function (evt) {
			};
		};

		DailyChallengeCalendar.prototype.buildColumnHeadings = function () {
			var dow = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

			var labelContainer = new PIXI.DisplayObjectContainer();

			for (var i = 0; i < dow.length; i++) {
				var dowString = _s("daysOfWeekAbbrv." + dow[i]);
				var label = new PIXI.Text(dowString, {
					fill: '#7fb5f8',
					font: this.calendarMenuDayOfWeekFontSize + 'px Arial',
					fontFamily: 'segoe',
					align: 'left',
					dropShadow: true,
					dropShadowBlur: 8,
					dropShadowColor: '#21456e',
					dropShadowAngle: 0,
					dropShadowDistance: 2
				}
				);
				label.position.set(
					Absolute.Coords.x(
						this.colSpace + (i * (DCDateTile.size.width + this.colSpace)) + (DCDateTile.size.width - label.width) / 2
					),
					Absolute.Coords.y(this.startingHeight + this.calendarPadding + this.calendarMenuDayOfWeekFontSize / 2)
				);
				label.anchor.set(0, .5);

				labelContainer.addChild(label)
			}

			this.addChild(labelContainer);
		};

		DailyChallengeCalendar.prototype.initInfoBox = function () {
			this.infoBox = new PIXI.Graphics();
			this.infoBox.beginFill(0x000000);
			this.infoBox.lineStyle(2, 0xffffff, 1);
			this.infoBox.drawRect(0, 0, Coords.x(300), Coords.x(80));
			this.infoBox.endFill();
			this.infoBox.x = 10;
			this.infoBox.y = 100;
			var text = new PIXI.Text(_s('DailyChallenge.notAvailable'), {
				font: 'Bold ' + 24 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff',
				align: 'left'
			});
			_s.shrinkToFit(text, 24, '', Absolute.Coords.x(290));
			text.anchor.y = 0.5;
			text.x = Coords.x(10);
			text.y = this.infoBox.height / 2;

			this.infoBox.addChild(text);
			this.infoBox.visible = false;
			this.addChild(this.infoBox);
		};

		DailyChallengeCalendar.prototype.buildCalendarGrid = function () {

			function tomorrow(d) {
				return new Date(d.getTime() + 24 * 3600 * 1000);
			}

			function isSameMonth(da, db) {
				return da.getMonth() === db.getMonth();
			}

			var today = new Date(),
				first = new Date(today.getFullYear(), today.getMonth(), 1),
				firstDoW = first.getDay(),
				current = null,
				day = 1;

			this.gridContainer = new PIXI.DisplayObjectContainer();

			this.dateTiles = [];

			var completed;
			for (var row = 0; row < 6; row++) {
				for (var col = 0; col < 7; col++) {

					if (row === 0 && col === firstDoW) {
						current = first;
						day = 1;
					}

					if (current) {
						completed = SolitaireDailyChallengeService.GetCompletedChallengeCountForDate(current);
					} else {
						completed = 0;
					}

					var dateTile = new DCDateTile(day, current, completed, this.onSelectDay.bind(this));
					dateTile.x = this.colSpace + (col * (dateTile.width + this.colSpace));
					dateTile.y = this.rowSpace + (row * (dateTile.height + this.rowSpace));
					dateTile.selected = current && current.getDate() === today.getDate();
					this.gridContainer.addChild(dateTile);
					this.dateTiles.push(dateTile);

					if (current) {
						current = tomorrow(current);

						if (!isSameMonth(first, current)) {
							current = null;
							day = 1;
						} else {
							day++;
						}
					}
				}
			}

			this.gridContainer.y = Coords.y(this.startingHeight + this.calendarPadding + this.calendarMenuDayOfWeekFontSize);
			this.addChild(this.gridContainer);
		};


		DailyChallengeCalendar.prototype.onSelectDay = function (date, available, target) {
			if (!available) {
				this.infoBox.visible = true;
				this.infoBox.x = target.x + target.width / 2;
				this.infoBox.y = target.y;
				clearTimeout(this.infoBoxTimeout);
				this.infoBoxTimeout = setTimeout(function () {
					this.infoBox.visible = false;
				}.bind(this), 3000);
			} else {
				_.each(this.dateTiles, function (dateTile) {
					if (dateTile.selected) {
						dateTile.selected = false;
						dateTile.onShow();
					}
				});
				this.dailyChallengeMenu.showLobbyForDate(date);
			}
		};

		DailyChallengeCalendar.prototype.onShow = function (firstRun) {
			if (!firstRun) {
				_.each(this.dateTiles, function (dateTile) {
					if (dateTile.date) {
						dateTile.onShow(SolitaireDailyChallengeService.GetCompletedChallengeCountForDate(dateTile.date));
						try {
							dateTile.removeChild(this.hoverGraphic);
						} catch (e) {
						}
					}
				});
			}
		};

		DailyChallengeCalendar.prototype.onHide = function (firstRun) {
			_.each(this.dateTiles, function (dateTile) {
				dateTile.onHide();
			});
		};

		return DailyChallengeCalendar;

	});

